import { render, staticRenderFns } from "./OverlayDescription.vue?vue&type=template&id=42aebe72&scoped=true"
import script from "./OverlayDescription.vue?vue&type=script&lang=js"
export * from "./OverlayDescription.vue?vue&type=script&lang=js"
import style0 from "./OverlayDescription.vue?vue&type=style&index=0&id=42aebe72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aebe72",
  null
  
)

export default component.exports